import React from 'react';
import Section from './Section';
import { FiTag, FiEdit, FiTrash } from "react-icons/fi";
import TagButton from "./TagButton";

function SectionKey(props) {
  return (
      <Section>
        <p className="font-bold text-xl">{props.theKey}</p>
        <p className="mb-4">{props.theVal}</p>
        <TagButton><FiEdit /> edit</TagButton>
        <TagButton><FiTag /> rename</TagButton>
        <TagButton><FiTrash /> delete</TagButton>
      </Section>
  );
}

export default SectionKey;
